import {
  MODAL_LAYER_ID,
  MODAL_LAYER_BOOTSTRAP_OPTIONS,
  MODAL_LAYER_PAYWALL_CONTENT_EVENT,
  MODAL_LAYER_TAG_MANAGER_SET_EVENT
} from '../constants';

const
  AGENCY_PATTERN = '/AG-|PG-|AT-|EP-|JM-|ACB/g',
  AGENCY = 'agen',
  VIDEOS = 'videos',
  VIDEO  = 'video',
  PHP    = 'php'
;

class ModalView {
  constructor(player, metadata) {
    this.player = player;
    this.metadata = metadata;
    this.container$ = Voonto.$(`#${MODAL_LAYER_ID}`);
  }

  fetch() {
    this.container$.empty();
    return this.player.fetch()
      .then((player) => this.container$.html(player))
      .then(() => this.container$.children().first().modal(MODAL_LAYER_BOOTSTRAP_OPTIONS))
      .then(() => this.pauseVideos())
      .then(() => this.bindEvents())
      .then(() => this.renderSocialButtons())
      .then(() => this.renderMenuUnderline())
      .then(() => this.tracking())
      .then(() => { Voonto.getInstance().trigger(MODAL_LAYER_PAYWALL_CONTENT_EVENT); })
    ;
  }

  pauseVideos() {
    $('video').each(function() {
      let video$ = $(this).get(0);
      // pause video
      if (video$ && !video$.paused) {
        return video$.pause();
      }
      // pause ad
      return setTimeout(()  => {
        if (video$
          && typeof videojs !== 'undefined'
          && videojs(video$.id)
          && videojs(video$.id).ima3
          && videojs(video$.id).ima3.adsManager) {
          videojs(video$.id).ima3.adsManager.pause();
        }
      }, 0);
    });
  }

  bindEvents() {
    this.container$.on('hide.bs.modal', () => this.container$.empty());
  }

  renderSocialButtons() {
    if (this.metadata.link) {
      this.container$.children().first().find('[data-voc-social-buttons]').socialButtons();
    }
  }

  renderMenuUnderline() {
    this.container$.children().first().find('[data-voc-animated-underline]').animatedUnderline();
  }

  tracking() {
    let source = 'rl';

    if (this.metadata.reference_id) {
      source = this.metadata.reference_id.substr(0, 3);
      source = source.match(AGENCY_PATTERN) ? AGENCY : source.split('-').shift().toLowerCase();
    }

    let subsecciones = [];

    if (this.metadata.tags) {
      let tags = this.metadata.tags;
      let linkurl = this.metadata.linkurl ? this.metadata.linkurl : '';

      Object.values(tags).forEach((tag) => {
        if (tag.indexOf('/main') !== -1) {
          let cats = tag.replace('/main', '').split('/');
          Object.values(cats).forEach((cat) => {
            subsecciones.push(cat.split('_').pop());
          });
          return false;
        } else if (linkurl.indexOf('/' + tag + '/') !== -1) {
          subsecciones = tag.split('/');
        }
        return true;
      });
    }

    Voonto.getInstance().trigger(MODAL_LAYER_TAG_MANAGER_SET_EVENT, {
      seccion:                 VIDEOS,
      subseccion1:             subsecciones[0] ? subsecciones[0] : '',
      subseccion2:             subsecciones[1] ? subsecciones[1] : '',
      subseccion3:             subsecciones[2] ? subsecciones[2] : '',
      subseccion4:             subsecciones[3] ? subsecciones[3] : '',
      titular:                 this.metadata.name,
      fechaPrimeraPublicacion: Voonto.moment(this.metadata.createdAt).format('YYYYMMDDkkmmss'),
      fechaModificacion:       Voonto.moment(this.metadata.updatedAt).format('YYYYMMDDkkmmss'),
      tipoContenido:           VIDEO,
      sistemaPublicacion:      PHP,
      firmaAutor:              this.metadata.author.name,
      origenContenido:         source
    });
  }
}

export default ModalView;



// WEBPACK FOOTER //
// ./src/views/modal.js